import React, { Component } from "react";
import { Button, Form, FormGroup, Label, Input, Col, Row } from 'reactstrap';
import BlockUi from 'react-block-ui';
import { reduxForm } from 'redux-form'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Messages from '../../notifications/Messages'
import Errors from '../../notifications/Errors'
import NumberFormat from 'react-number-format';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import * as chuongTrinhAction from './actions'
import * as cTrinhConstants from './constants'
import { storedb } from '../client/storedb'
import { BtnPermissions, BtnType } from '../../lib/BtnPermissions';
import { ButtonExt } from "../controls/ButtonExt"

class ChuongTrinhEdit extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    chuongTrinhUpdateRequest: PropTypes.func,
    chuongTrinhDetailRequest: PropTypes.func,
    chuongTrinhListRequest: PropTypes.func,
    chuongTrinhEdit: PropTypes.shape({
      item: PropTypes.object,
      listDvt: PropTypes.array,
      type: PropTypes.string,
      listRequesting: PropTypes.bool,
      requesting: PropTypes.bool,
      successful: PropTypes.bool,
      messages: PropTypes.array,
      errors: PropTypes.array,
    }),
  }
  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      item: {},
      formError: {},
      formValid: false,
      StoreId: dbContext.getStoreId(),
      showDoanhSoApDung: false,
      showSoLuongApDung: false,
      showPhanTramChietKhau: false,
      showLoaiKh: false,
    };
  }
  getParam = (name) => {
    const queryParamsString = this.props.location.search.substring(1),
      searchParams = new URLSearchParams(queryParamsString);
    return searchParams.get(name);
  }
  handleControlChange = (e) => {
    let { item } = this.state
    item[e.target.name] = e.target.value
    this.setState({ item })
  }
  handleSelectChange = (name, selectedOption) => {
    let { item } = this.state;
    var loai = 0;
    switch (name) {
      case "TrangThai":
        item.IsActive = selectedOption.target.value
        break;
      case "NhomKhachHang":
        item.NhomKhachHangId = selectedOption.target.value
        break;
      case "Loai":
        loai = selectedOption.target.value;
        item.DoanhSoApDung = 0;
        item.PercentCk = 0;
        item.SoLuongApDung = 0;
        item.Loai = loai;
        break;
      default:
        break;
    }
    this.setState({ item }, () => {
      if (loai > 0) {
        this.SetKieuChuongTrinh(loai);
      }
    })
  }
  SetKieuChuongTrinh = (loai) => {
    let {
      showDoanhSoApDung,
      showPhanTramChietKhau,
      showSoLuongApDung,
      showLoaiKh
    } = this.state

    switch (loai * 1) {
      case cTrinhConstants.CHUONGTRINH_KIEU_ENUM.CK_CODINH_THEO_NHOM:
        showDoanhSoApDung = false;
        showPhanTramChietKhau = true;
        showSoLuongApDung = false;
        showLoaiKh = false
        break;
      case cTrinhConstants.CHUONGTRINH_KIEU_ENUM.CK_THEM_THEO_SP:
        showDoanhSoApDung = false;
        showPhanTramChietKhau = true;
        showSoLuongApDung = true;
        showLoaiKh = false
        break;
      case cTrinhConstants.CHUONGTRINH_KIEU_ENUM.CK_TANG_HANG:
        showDoanhSoApDung = false;
        showPhanTramChietKhau = false;
        showSoLuongApDung = true;
        showLoaiKh = true
        break;
      case cTrinhConstants.CHUONGTRINH_KIEU_ENUM.CK_THEO_DON:
        showDoanhSoApDung = true;
        showPhanTramChietKhau = true;
        showSoLuongApDung = false;
        showLoaiKh = false
        break;
      case cTrinhConstants.CHUONGTRINH_KIEU_ENUM.CK_THEM_THEO_NHOM:
        showDoanhSoApDung = true;
        showPhanTramChietKhau = true;
        showSoLuongApDung = false;
        showLoaiKh = false
        break;
      case cTrinhConstants.CHUONGTRINH_KIEU_ENUM.KHONG_CK:
        showDoanhSoApDung = false;
        showPhanTramChietKhau = false;
        showSoLuongApDung = false;
        showLoaiKh = false
        break;
      default:
        showDoanhSoApDung = false;
        showPhanTramChietKhau = false;
        showSoLuongApDung = false;
        showLoaiKh = false
        break;
    }
    this.setState({ showDoanhSoApDung, showPhanTramChietKhau, showSoLuongApDung, showLoaiKh })
  }
  handleMoneyChange = (name, data) => {
    let { item } = this.state;
    const value = data.floatValue;
    item[name] = value;
    this.setState({ item })
  }
  handleDateChange = (name, obj) => {
    let { item } = this.state;
    switch (name) {
      case "NgayApDung":
        item.NgayApDung = obj.format();
        break;
      case "NgayKetThuc":
        item.NgayKetThuc = obj.format();
        break;
      default:
        break;
    }
    this.setState({ item })
  }
  numberOnclick = (e) => {
    e.currentTarget.setSelectionRange(0, e.currentTarget.value.length)
  }
  Cancel = () => {
    this.featchDetail();
  }
  featchDetail = () => {
    const { chuongTrinhDetailRequest } = this.props
    let ChuongTrinhId = this.getParam("cid");
    var requestData = {
      ChuongTrinhId: ChuongTrinhId || 0,
      StoreId: this.state.StoreId
    }
    return chuongTrinhDetailRequest(requestData);
  }
  UpdateChuongTrinh = () => {
    let formError = {};
    let formValid = true;
    if (!this.state.item.Loai || this.state.item.Loai == 0) {
      formError.Loai = 'Bạn chưa nhập kiểu chương trình';
    }
    if (!this.state.item.TenChuongTrinh || this.state.item.TenChuongTrinh == "") {
      formError.TenChuongTrinh = 'Bạn chưa nhập tên chương trình';
    }
    if (this.state.item.IsActive == undefined || this.state.item.IsActive == -1) {
      formError.IsActive = 'Bạn chưa nhập trạng thái';
    }
    for (var prp in formError) {
      if (prp && formError[prp] != '') {
        formValid = false;
        break;
      }
    }
    this.setState({ formError, formValid });
    if (formValid) {
      let { item } = this.state;
      item.StoreId = this.state.StoreId;
      this.props.chuongTrinhUpdateRequest(item);
    }
  }
  BackToListChuongTrinh = (item, e) => {
    this.props.history.push('/chuong-trinh');
  }
  componentDidMount() {
    this.featchDetail();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.chuongTrinhEdit.type == cTrinhConstants.CHUONGTRINH_DETAIL_SUCCESS) {
      let { item } = nextProps.chuongTrinhEdit;
      if (item.ChuongTrinhId && item.ChuongTrinhId > 0) {
        this.setState({ item: item }, () => {
          this.SetKieuChuongTrinh(item.Loai);
        });
      }
    } else if (nextProps.chuongTrinhEdit.type == cTrinhConstants.CHUONGTRINH_UPDATE_SUCCESS) {
      this.props.history.push("/chuong-trinh");
    }
  }
  convertToMoment = (date) => {
    if (typeof date == 'string') {
      return moment(date);
    }
    return date;
  }
  render() {
    const { formError, item } = this.state;
    const {
      handleSubmit,
      chuongTrinhEdit: {
        isRequesting,
        errors,
        messages
      },
    } = this.props

    const genKieuCtrinh = () => {
      return cTrinhConstants.CHUONGTRINH_LIST_KIEU.map((item, index) => {
        return (
          <option key={index} value={item.id}>{item.name}</option>
        )
      })
    }

    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={false} >
          <Form className="row">
            <FormGroup className="col-sm-6">
              <Label>Kiểu chương trình</Label>
              <select name="Loai" className="form-control" value={item.Loai} onChange={this.handleSelectChange.bind(this, "Loai")}>
                <option value={0}>--Kiểu Chương trình--</option>
                {genKieuCtrinh()}
              </select>
              <em className="error invalid-feedback">{formError.Loai}</em>
            </FormGroup>
            <FormGroup className={this.state.showLoaiKh ? "col-sm-6" : "d-none"}>
              <Label>Nhóm khách hàng</Label>
              <select name="NhomKhachHang" className="form-control" value={item.NhomKhachHangId} onChange={this.handleSelectChange.bind(this, "NhomKhachHang")}>
                <option value={0}>--Nhóm khách hàng--</option>
                <option value={cTrinhConstants.CHUONGTRINH_NHOM_KH_ENUM.KH_MOI}>
                  {cTrinhConstants.CHUONGTRINH_NHOM_KH_ENUM.KH_MOI_TEXT}
                </option>
                <option value={cTrinhConstants.CHUONGTRINH_NHOM_KH_ENUM.KH_LE}>
                  {cTrinhConstants.CHUONGTRINH_NHOM_KH_ENUM.KH_LE_TEXT}
                </option>
                <option value={cTrinhConstants.CHUONGTRINH_NHOM_KH_ENUM.KH_HD}>
                  {cTrinhConstants.CHUONGTRINH_NHOM_KH_ENUM.KH_HD_TEXT}
                </option>
              </select>
              <em className="error invalid-feedback">{formError.NhomKhachHangId}</em>
            </FormGroup>
            <FormGroup className="col-sm-6">
              <Label >Tên chương trình</Label>
              <Input type="text" name="TenChuongTrinh" placeholder="Tên chương trình" value={item.TenChuongTrinh || ''} onChange={this.handleControlChange.bind(this)} />
              <em className="error invalid-feedback">{formError.TenChuongTrinh}</em>
            </FormGroup>
            <FormGroup className="col-sm-3">
              <div><Label >Ngày bắt đầu</Label></div>
              <DatePicker name="NgayApDung" dateFormat="DD/MM/YYYY" selected={this.convertToMoment(item.NgayApDung)} onChange={this.handleDateChange.bind(this, "NgayApDung")} className={"form-control"} />
              <em className="error invalid-feedback">{formError.NgayApDung}</em>
            </FormGroup>
            <FormGroup className="col-sm-3">
              <div><Label >Ngày kết thúc</Label></div>
              <DatePicker name="NgayKetThuc" dateFormat="DD/MM/YYYY" selected={this.convertToMoment(item.NgayKetThuc)} onChange={this.handleDateChange.bind(this, "NgayKetThuc")} className={"form-control"} />
              <em className="error invalid-feedback">{formError.NgayKetThuc}</em>
            </FormGroup>
            <FormGroup className={this.state.showDoanhSoApDung ? "col-sm-6" : "d-none"}>
              <Label>Doanh số áp dụng</Label>
              <NumberFormat
                name={"DoanhSoApDung"}
                value={item.DoanhSoApDung}
                defaultValue={0}
                thousandSeparator={"."}
                decimalSeparator={","}
                type="tel"
                onClick={this.numberOnclick.bind(this)}
                onValueChange={this.handleMoneyChange.bind(this, "DoanhSoApDung")}
                className={"form-control order-input-price price"} />
            </FormGroup>
            <FormGroup className={this.state.showSoLuongApDung ? "col-sm-6" : "d-none"}>
              <Label >Số lượng áp dụng</Label>
              <NumberFormat
                name={"SoLuongApDung"}
                value={item.SoLuongApDung}
                defaultValue={0}
                thousandSeparator={"."}
                decimalSeparator={","}
                type="tel"
                onClick={this.numberOnclick.bind(this)}
                onValueChange={this.handleMoneyChange.bind(this, "SoLuongApDung")}
                className={"form-control order-input-price price"} />
            </FormGroup>
            <FormGroup className={this.state.showPhanTramChietKhau ? "col-sm-6" : "d-none"}>
              <Label>Phần trăm chiết khấu</Label>
              <NumberFormat
                name={"PercentCk"}
                value={(item.PercentCk || 0) * 1}
                defaultValue={0}
                thousandSeparator={"."}
                decimalSeparator={","}
                type="tel"
                onClick={this.numberOnclick.bind(this)}
                onValueChange={this.handleMoneyChange.bind(this, "PercentCk")}
                className={"form-control order-input-price price"} />
            </FormGroup>
            <FormGroup className="col-sm-6">
              <Label>Trạng thái</Label>
              <select name="IsActive" className="form-control" value={item.IsActive} onChange={this.handleSelectChange.bind(this, "TrangThai")}>
                <option value={-1}>--Trạng thái--</option>
                <option value={0}>Chưa chạy chương trình</option>
                <option value={1}>Đang chạy chương trình</option>
              </select>
              <em className="error invalid-feedback">{formError.IsActive}</em>
            </FormGroup>
            <FormGroup className="col-sm-12">
              <Label>Ghi chú</Label>
              <Input type="textarea" name="GhiChu" className="form-control" value={item.GhiChu || ''} onChange={this.handleControlChange.bind(this)} />
            </FormGroup>
          </Form>
          <Row>
            <Col md="12">
              {!isRequesting && !!errors.length && (
                <Errors errors={errors} />
              )}
              {!isRequesting && !!messages.length && (
                <Messages messages={messages} />
              )}
            </Col>
          </Row>
          <div className="w-100 mb-2">
            <ButtonExt btnClass="mr-1"
              color="success"
              iconClass="fa-list"
              displayText="Về Danh sách"
              btnClick={() => this.BackToListChuongTrinh()}
              permission={""} />
            <ButtonExt btnClass="mr-1"
              color="primary"
              iconClass="fa-save"
              displayText="Lưu"
              btnClick={() => this.UpdateChuongTrinh()}
              permission={BtnPermissions.ChuongTrinh.ADD_OR_UPDATE} />
          </div>
        </BlockUi>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  chuongTrinhEdit: state.chuongTrinhEdit,
})
const connected = connect(mapStateToProps, {
  chuongTrinhDetailRequest: chuongTrinhAction.chuongTrinhDetailRequest,
  chuongTrinhUpdateRequest: chuongTrinhAction.chuongTrinhUpdateRequest,
  chuongTrinhListRequest: chuongTrinhAction.chuongTrinhListRequest,
})(ChuongTrinhEdit)

const formed = reduxForm({
  form: 'chuongTrinhEdit',
})(connected)

export default formed;


// WEBPACK FOOTER //
// ./src/views/ChuongTrinh/ChuongTrinhEdit.js